module.exports = __webpack_public_path__ + "img/info-prod.78374e02.svg";